module.exports = '<svg width="144" height="116" viewBox="0 0 144 116"><path d="M129.6 14.5H72L57.6 0H14.4C6.48 0 .072 6.525.072 14.5L0 101.5c0 7.975 6.48 14.5 14.4 14.5h115.2c7.92 0 14.4-6.525 14.4-14.5V29c0-7.975-6.48-14.5-14.4-14.5zM129 101H14V29h115v72z" fill="#444"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/folder-2.js
// module id = 1155
// module chunks = 14